import qr from '../../utils/qrcode/qrcode';
import { Component, h, Prop } from '@stencil/core';
import { ErrorCorrectionLevel } from './enums';

const QRC = qr.QrCode;

@Component({
  tag: 'qr-code',
})
export class QRCode {
  @Prop() url!: string;
  @Prop() level?: ErrorCorrectionLevel = ErrorCorrectionLevel.M;
  @Prop() class?: string = '';
  @Prop() color?: string = 'black';

  render() {
    const getEcc = (ecc: string) => {
      ecc = ecc.toUpperCase();
      if (ecc === 'L') return QRC.Ecc.LOW;
      if (ecc === 'M') return QRC.Ecc.MEDIUM;
      if (ecc === 'Q') return QRC.Ecc.QUARTILE;
      return QRC.Ecc.HIGH;
    };

    const ecc = getEcc(this.level);

    const qr = QRC.encodeText(this.url, ecc);
    const qrcode = qr.svgObject();

    return (
      <svg class={this.class} viewBox={`0 0 ${qrcode.size} ${qrcode.size}`}>
        <path d={qrcode.path} fill={this.color} />
      </svg>
    );
  }
}
